import React, { useState, useEffect } from 'react'
import { Switch, Route, useLocation } from 'react-router-dom';
import Login from './Login/Email';
import Mobile from './Login/Mobile';
import FirstTimeSetup from './FirstTimeSetup';
import NewPassword from './ResetPassword'
import CodeLogin from './Login/Code'
import NotFound from '../NotFound';
import SSOLogin from './Login/SSO';
import Google_Redirect from './Login/SSO/Google_Redirect';
import GetAuthorizationCode from './Login/SSO/Google_Redirect/getAuthorizationCode'
import AiBot from './AiBot/AiBot';

function Index() {

	const {search} = useLocation()
    const Params = new URLSearchParams(search)
    const GoogleLogin = Params.get('state')
    const GoogleCode = Params.get('code')
	const [devMode, setDevMode] = useState(false)

	useEffect(() => {
		if(search && search.length && (search.includes('origin=employee.dev.eka.io') || search.includes('origin=employee.dice.tech'))){
			setDevMode(true)
		}
		else{
			setDevMode(false)
		}
	}, [search])

	//Checking if app has be redirected from google sso login success
	if(GoogleLogin&&GoogleLogin==='GOOGLE_LOGIN'){
		if(GoogleCode){
			GetAuthorizationCode(GoogleCode)
		}
	}

	return (
		<>
		{devMode ? <AiBot/> : null}
		<Switch>
			<Route path="/google_redirect" component={Google_Redirect} exact={true} />
			<Route path="/sso" component={SSOLogin} exact={true} />
			<Route path="/code" component={CodeLogin} exact={true} />
			<Route path="/reset" component={NewPassword} exact={true} />
			<Route path="/setup" component={FirstTimeSetup} exact={true} />
			<Route path="/mobile" component={Mobile} exact={true} />
			<Route path="/" component={Login} exact={true} />
			<NotFound/>
		</Switch>
		</>
	)

}

export default Index
